var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "collapse navbar-collapse menu-links",
      attrs: { id: _vm.toggleID }
    },
    [
      _c(
        "b-nav",
        { staticClass: "navbar-nav ml-auto" },
        [
          _c("b-nav-item", { attrs: { to: "/", exact: "" } }, [_vm._v("Home")]),
          _c("b-nav-item", { attrs: { to: "/about" } }, [_vm._v("About")]),
          _c("b-nav-item", { attrs: { to: "/version" } }, [_vm._v("Version")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }